<template>
  <section class="signin">
    <v-container class="container--fluid fill-height pa-0">
      <v-row no-gutters align-content="center" justify="center">
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-card class="signin-card">
            <div class="sign-in-header">
              <img
                src="../../assets/logo-BirchEquipment-old.png"
                class="company-logo"
              />
            </div>
            <v-card-text>
              <v-form ref="form" v-model="valid" class="auth-form">
                <v-alert outlined type="error" text v-if="isError">
                  {{ errorText }}
                </v-alert>
                <h4 class="form-head">Sign In</h4>
                <div class="label-text">Email Address</div>
                <v-text-field
                  v-model="username"
                  class="mb-3"
                  outlined
                  dense
                  append-icon="mdi-account-outline"
                  autocomplete="off"
                  :name="Math.random()"
                  placeholder="Email Address"
                  required
                  :rules="rules.emailRules"
                  v-on:keyup.enter="login()"
                />
                <div class="label-text">Password</div>
                <v-text-field
                  v-model="password"
                  class="mb-3"
                  outlined
                  dense
                  persistent-hint
                  :type="hidePassword ? 'password' : 'text'"
                  :append-icon="
                    hidePassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'
                  "
                  autocomplete="off"
                  :name="Math.random()"
                  placeholder="Password"
                  :rules="rules.passwordRules"
                  required
                  @click:append="hidePassword = !hidePassword"
                  v-on:keyup.enter="login()"
                />
              </v-form>
            </v-card-text>
            <v-card-actions class="card-actions">
              <v-btn
                class="primary-btn"
                :loading="loading"
                @click="login"
                style="width: 100%"
              >
                Sign In
              </v-btn>
            </v-card-actions>
            <div class="pt-4 pb-4 pl-10">
              <a class="forgot-password" @click="routeToForgotPassword"
                >Forgot Password?</a
              >
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<style scoped lang="scss">
@import "../../assets/styles/variables.scss";
.sign-in-header {
  border-bottom: 1px solid $neutral-gray-2;
  padding: 16px 48px;
  height: 120px !important;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  background-color: $black-shade-3;
}
.signin-card {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  background-color: $neutral-white;
  position: relative;
  overflow: auto;
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  min-width: 300px;
}
.form-head {
  line-height: 1.5;
  margin-top: 10px;
  margin-bottom: 25px;
  text-align: center;
  text-transform: none;
  font-weight: 600;
}
.company-logo {
  width: 100%;
  height: auto;
}
.auth-form {
  padding: 0 20px;
}

.card-actions {
  padding: 0 35px;
}
.forgot-password {
  margin-top: 15px;
  color: #bf2e1a;
  text-decoration: none;
  font-weight: normal;
}
.label-text {
  font-weight: 500;
}
</style>

<script>
import rules from "../../utils/rules";
import EventBus from "../../utils/EventBus";

export default {
  name: "SignIn",
  data: () => ({
    loading: false,
    valid: false,
    username: "",
    password: "",
    errorText: "",
    isError: false,
    rules: rules,
    hidePassword: true,
  }),

  methods: {
    routeToForgotPassword() {
      this.$router.push("/forgotpassword");
    },
    async login() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        let result = await this.$store.dispatch("LoginByEmail", {
          userName: this.username,
          password: this.password,
          grant_type: "password",
        });

        if (result) {
          this.loading = false;
          EventBus.$emit("mini", true);
          try {
            if (this.$store.getters.firstTimeLogin) {
              //redirect to change password page
              await this.$router.push("/first-time-change-password");
            } else {
              if (this.$store.getters.twoFactorEnabled) {
                //redirect to two factor authenticate page
                await this.$router.push("/two-factor-authenticate");
              } else {
                //redirect to home page
                await this.$router.push(this.$route.query.redirect || "/");
              }
            }
          } catch (err) {
            console.log(err);
            throw new Error(`Problem handling something: ${err}.`);
          }
        } else {
          this.loading = false;
          this.isError = true;
          this.errorText = "Invalid Username or Password, Please try again";
          setTimeout(() => (this.isError = false), 2000);
        }
      } else {
        this.loading = false;
      }
    },
  },
};
</script>
